import { http as atsHttp } from '@/lib/ats-https';
import { http } from '@/lib/http';

const getDegreeDetails = async () => {
  const response = await atsHttp.get(`/academics/degrees`);
  return response.data;
};

const getCandidateDetails = async (id) => {
  const candidate = await http.get(`/contacts/${id}`);
  return candidate;
};

export { getDegreeDetails, getCandidateDetails };
